import { render, staticRenderFns } from "./StatisticCardVerticalNotGenerated.vue?vue&type=template&id=53039af6&"
import script from "./StatisticCardVerticalNotGenerated.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalNotGenerated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports